import { SpherePlatformApp } from '../types/platform-app';
import { AppRoute } from '../types';

export class SpherePlatformApps {
    private readonly apps = new Map<string, SpherePlatformApp>();

    constructor(apps?: SpherePlatformApp[]) {
        if (apps && Array.isArray(apps) && apps?.length > 0) {
            this.registerSphereApps(apps);
        }
    }

    public registerSphereApp(app: SpherePlatformApp) {
        const rootPath = app.APP.path || app.APP.data.id;
        if (this.apps.has(rootPath)) {
            console.warn(`sphere application ${app.APP.path} has already been registered`, app);
            return;
        }
        console.debug(`[SpherePlatformAppsService]: register app with root path ${app.APP.path}`, app);
        this.apps.set(rootPath, app);
    }

    public registerSphereApps(apps: SpherePlatformApp[]) {
        for (const app of apps) {
            this.registerSphereApp(app);
        }
    }

    public get sphereApps() {
        return Array.from(this.apps.values());
    }

    public get sphereAppMap() {
        return this.apps;
    }

    public get sphereAppRoutes(): AppRoute[] {
        return this.sphereApps.map(appDefinition => appDefinition.APP);
    }
}
